import { ButtonGroup, Icon, Modal } from 'glints-aries/es/@next';
import { Blue } from 'glints-aries/es/@next/utilities/colors';
import { space4 } from 'glints-aries/es/@next/utilities/spacing';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const StyledSuccessModal = styled(Modal)`
  .modal-content {
    box-sizing: border-box;
    width: 100%;
  }
`;

export const purchaseSuccessModalStyle = {
  width: '100%',
  maxWidth: 620,
} as const;

export const SuccessModalIntro = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  width: 100%;
  text-align: center;
`;

export const SuccessModalSummary = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space4};
`;

export const SuccessModalLink = styled(Link)`
  color: ${Blue.S99};

  &:hover {
    color: ${Blue.S100};
  }
`;

export const ProductIcon = styled.img`
  width: 72px;
  height: 72px;
`;

export const StyledButtonGroup = styled(ButtonGroup)`
  justify-content: flex-end;
`;

export const SuccessIcon = styled(Icon)`
  border: 3px dashed #00aa7f;
  border-radius: 50%;
  padding: 20px;
`;
